import React from 'react';
import { Box, Typography, Container, Button, Grid, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UpcomingMeetingBanner from './UpcomingMeetingBanner';

function Home() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <Box>
      <UpcomingMeetingBanner />
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          py: 12,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: 'linear-gradient(135deg, rgba(19, 78, 111, 0.9) 0%, rgba(14, 58, 82, 0.9) 100%)',
            zIndex: 1,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
          <Typography variant="h2" component="h1" gutterBottom sx={{ color: 'white' }}>
            {t('Home.HeroTitle')}
          </Typography>
          <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
            {t('Home.HeroSubtitle')}
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: 'accent.goldenYellow',
              color: 'primary.dark',
              fontWeight: 'bold',
              '&:hover': { backgroundColor: '#e0a905' }
            }}
            onClick={() => navigate(`/${i18n.language}/rolunk`)}
          >
            {t('Home.LearnMore')}
          </Button>
        </Container>
      </Box>

      {/* Highlights Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <Box sx={{ height: 10, backgroundColor: 'accent.brickRed' }} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" color="primary">
                  {t('Home.SajtoRadarTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('Home.SajtoRadarDesc')}
                </Typography>
                <Button sx={{ mt: 2 }} onClick={() => navigate(`/${i18n.language}/sajtoradar`)}>{t('Home.View')}</Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <Box sx={{ height: 10, backgroundColor: 'accent.goldenYellow' }} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" color="primary">
                  {t('Home.FeltarasokTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('Home.FeltarasokDesc')}
                </Typography>
                <Button sx={{ mt: 2 }} onClick={() => navigate(`/${i18n.language}/feltarasok`)}>{t('Home.View')}</Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <Box sx={{ height: 10, backgroundColor: 'accent.oliveGreen' }} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" color="primary">
                  {t('Home.CollectionsTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('Home.CollectionsDesc')}
                </Typography>
                <Button sx={{ mt: 2 }} onClick={() => navigate(`/${i18n.language}/gyujtemenyek`)}>{t('Home.View')}</Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <Box sx={{ height: 10, backgroundColor: 'accent.warmOrange' }} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" color="primary">
                  {t('Home.MeetingTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('Home.MeetingDesc')}
                </Typography>
                <Button sx={{ mt: 2 }} onClick={() => navigate(`/${i18n.language}/talalkozo`)}>{t('Home.Details')}</Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <Box sx={{ height: 10, backgroundColor: 'secondary.main' }} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" color="primary">
                  {t('Home.GSSTTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('Home.GSSTDesc')}
                </Typography>
                <Button sx={{ mt: 2 }} onClick={() => navigate(`/${i18n.language}/gsst`)}>{t('Home.OpenMap')}</Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Home;
